<template>

	<div>	

		<div class="columns">

			<!-- https://davidwalsh.name/css-flip -->

			<div class="content column">
				<br/>
				<p>Our City Plan 2030 aims to create a place where people love to be and provide opportunities to participate in and experience local arts and cultural activities. With our culturally rich and diverse community, we have become an important and vibrant arts hub - home to a significant number of artists, galleries, studios, museums, cultural organisations and events.</p>

				<p>This will be showcased on Friday 10 August for the AFTER DARK – SALA in the Port event, organised by the local Port Adelaide Guide, featuring 29 different venues – all within walking distance of each other. On the same night the Studios Potters SA in Klemzig will be launching their Fired Up…Open Studio Weekend. There are a number of other Open Studios operating during the SALA month too. REAL (Rare Earth Artists Lab) will be operating Rare Earth: Graft dawn and dust tours through the streets of Port Adelaide. Semaphore’s Hidden Histories, a City of Port Adelaide Enfield Placemaking Project, which will feature paste-up images along Semaphore Road curated by Artist Rachel Harris – grab the map and check them out.</p>

				<p>Grab some friends and the City of PAE SALA Guide 2018 and make sure you enjoy everything this world-class festival has to offer.</p>

				<p>For full details of all SALA exhibitions and events, go to <a href="http://www.salafestival.com" target="_blank">www.salafestival.com</a></p>

			</div>

		</div>


		<div class="columns" style="margin-top: 4em;">
			<div class="column is-full">
				<div class="columns">
					<div class="column is-one-third-tablet is-full-mobile" v-for="(card, index) in featuredCards">
						<card :info="card"></card>
					</div>
				</div>
			</div>
		</div>



<br/>

		<div class="columns is-multiline">
			<div style="padding: 1em;">
				<p class="title is-4" style="margin-bottom: 0.5em;">Filter by Suburb:</p> 
				<ul class="serviceFilter">
					<li style="padding: .25em .5em; margin: 2px; line-height: 2.5em; display:inline-block; -webkit-column-break-inside: avoid; page-break-inside: avoid; break-inside: avoid;" @click="clearSuburbs()" :class="{'active':suburbFilter.length==0}">ALL</li>

					<li style="padding: .25em .5em; margin: 2px; line-height: 2.5em; display:inline-block; -webkit-column-break-inside: avoid; page-break-inside: avoid; break-inside: avoid;" v-for="(suburb, index) in suburbList" @click="toggleSuburb(index, suburb.name, !suburb.active)" :class="{'active':suburb.active}">{{ suburb.name }}</li>
				</ul>
			</div>
		</div>


		<div class="columns is-multiline is-mobile is-gapless">
			<div class="column is-one-third-desktop is-half-tablet is-full-mobile" v-for="(card, index) in filteredItems">
				<card :info="card"></card>
			</div>
		</div>

	</div>

</template>
<script>
	var Vue = require('vue');
	import card from './Card';

	export default {

        components: {
          card
        },

		data() {
			return {
				selectedCard: -1,

				suburbFilter: [],
				suburbList: [
					{ name: 'Alberton', active: false},
					{ name: 'Birkenhead', active: false},
					{ name: 'Broadview', active: false},
					{ name: 'Enfield', active: false},
					{ name: 'Ethelton', active: false},
					{ name: 'Exeter', active: false},
					{ name: 'Kilburn', active: false},
					{ name: 'Klemzig', active: false},
					{ name: 'Largs Bay', active: false},
					{ name: 'New Port', active: false},
					{ name: 'Northfield', active: false},
					{ name: 'Port Adelaide', active: false},
					{ name: 'Semaphore', active: false},
				],				

				featuredCards: [

							{
								"image": "pae-sala-guide.jpg",
								"imageCredit": null,
								"artist": "",
								"group": null,
								"title": "Port Adelaide Enfield SALA Guide",
								"venue": null,
								"address": null,
								"suburb": null,
								"website3": "http://images.portenf.sa.gov.au/book/community/sala-booklet/2018/",
							},
							{
								"image": "hidden.jpg",
								"imageCredit": "Rachel Harris",
								"artist": ['Rachel Harris','Semaphore Residents'],
								"group": null,
								"title": "Semaphore's Hidden Histories",
								"venue": "Semaphore Library and Semaphore Road precinct",
								"address": "14 Semaphore Road",
								"suburb": "Semaphore",
								"website": "https://www.salafestival.com/artfuel/program/view/1373/semaphores-hidden-histories",
								"website2": "https://www.cityofpae.sa.gov.au/page.aspx?c=54746",
							},
							{
								"image": "afterdark.jpg",
								"imageCredit": null,
								"artist": "",
								"group": "Various",
								"title": "AFTERDARK - SALA in the Port",
								"overideAddress": "Commercial Road and St Vincent Street, Port Adelaide",
								"venue": "20 Port Adelaide Venues",
								"address": "Numerous streets",
								"suburb": "Port Adelaide",
								"website": "https://www.salafestival.com/artfuel/program/view/1333/after-dark---sala-in-the-port",
								"website2": "https://www.cityofpae.sa.gov.au/sitedata/unity/resources/files/Info_AfterDark_SALA.pdf"
							},
 
				],


				cards: 
					[
					  {
					    "image": "bigpicture.jpg",
					    "imageCredit": null,
					    "artist": ['Jake Holmes','Bohie Palecek'],
					    "group": null,
					    "title": "The BIG Picture Fest",
					    "venue": "Largs Bay Sailing Club",
					    "address": "1 The Foreshore, Lady Gowrie Drive",
					    "suburb": "Largs Bay",
					    "website4": "http://www.thebigpicturefest.com"
					  },
					  {
					    "image": "hidden.jpg",
					    "imageCredit": "Rachel Harris",
					    "artist": ['Rachel Harris','Semaphore Residents'],
					    "group": null,
					    "title": "Semaphore's Hidden Histories",
					    "venue": "Semaphore Library and Semaphore Road precinct",
					    "address": "14 Semaphore Road",
					    "suburb": "Semaphore",
					    "website": "https://www.salafestival.com/artfuel/program/view/1373/semaphores-hidden-histories",
					    "website2": "https://www.cityofpae.sa.gov.au/page.aspx?c=54746",
					  },
					  {
					    "image": "kami.jpg",
					    "imageCredit": "Kai Benyk",
					    "artist": ['Kai Benyk','Candace Wylde'],
					    "group": null,
					    "title": "Kami",
					    "venue": "Queenies Store",
					    "address": "9 Jetty Road",
					    "suburb": "Largs Bay",
					    "website": "https://www.salafestival.com/artfuel/program/view/1110/kami"
					  },
					  {
					    "image": "miracleof.jpg",
					    "imageCredit": "Helen Grant-Johnston",
					    "artist": ['Helen Grant-Johnston'],
					    "group": null,
					    "title": "The Miracle of Creative Mandalas",
					    "venue": "Swedish Tarts Patisserie",
					    "address": "40 Semaphore Road",
					    "suburb": "Semaphore",
					    "website": "https://www.salafestival.com/artfuel/program/view/598/the-miracle-of-creative-mandalas"
					  },
					  {
					    "image": "greatbarrierreef.jpg",
					    "imageCredit": "Kayla Morgan",
					    "artist": ['Kayla Morgan'],
					    "group": null,
					    "title": "Great Barrier Reef",
					    "venue": "Mr Pilgrim Cafe",
					    "address": "67 Semaphore Road",
					    "suburb": "Semaphore",
					    "website": "https://www.salafestival.com/artfuel/program/view/1228/great-barrier-reef"
					  },
					  {
					    "image": "captivating.jpg",
					    "imageCredit": "Fiona McCaul",
					    "artist": ['Fiona McCaul'],
					    "group": null,
					    "title": "Captivating or Captive",
					    "venue": "Sweet Amber",
					    "address": "67a Semaphore Road",
					    "suburb": "Semaphore",
					    "website": "https://www.salafestival.com/artfuel/program/view/925/captivating-or-captive"
					  },
					  {
					    "image": "semaphoreink.jpg",
					    "imageCredit": "Blaise Butler",
					    "artist": ['Peter Elers','Andrew Paris','Joel Dylan','Daniel Carter','Anthony Candlish','Blaise Butler','Sarah Dawn'],
					    "group": "Semaphore Ink Collective",
					    "title": "Lucky 7",
					    "venue": "Semaphore Ink",
					    "address": "118 Semaphore Road",
					    "suburb": "Semaphore",
					    "website": "https://www.salafestival.com/artfuel/program/view/51/lucky-7"
					  },
					  {
					    "image": "maggiemccabe.jpg",
					    "imageCredit": "Maggie McCabe",
					    "artist": ['Maggie McCabe','Bill Doble'],
					    "group": "Artists from the Painting Room",
					    "title": "How to remain an artist",
					    "venue": "The Painting Room",
					    "address": "4/120 Semaphore Road",
					    "suburb": "Semaphore",
					    "website": "https://www.salafestival.com/artfuel/program/view/1054/how-to-remain-an-artist"
					  },
					  {
					    "image": "seedsofaffinity.jpg",
					    "imageCredit": "Charlotte Bedford",
					    "artist": "",
					    "group": "Seeds of Affinity",
					    "title": "Leaving prison behind: images and voices of women",
					    "venue": "Semaphore Uniting Church",
					    "address": "146 Semaphore Road",
					    "suburb": "Exeter",
					    "website": "https://www.salafestival.com/artfuel/program/view/1214/leaving-prison-behind-images-and-voices-of-women"
					  },
					  {
					    "image": "animal.jpg",
					    "imageCredit": "Mark Lobert",
					    "artist": ['Mark Lobert'],
					    "group": null,
					    "title": "Animal party",
					    "venue": "Red Mill Bake House",
					    "address": "139 Bower Road",
					    "suburb": "Ethelton",
					    "website": "https://www.salafestival.com/artfuel/program/view/1514/animal-party"
					  },
					  {
					    "image": "portobello.jpg",
					    "imageCredit": "Linda Buttfield",
					    "artist": ['Linda Buttfield','Elly Byrne'],
					    "group": null,
					    "title": "People Colour Our World",
					    "venue": "Portobello Waterfront Restaurant",
					    "address": "Waterfront, 1-2 Wirra Drive",
					    "suburb": "New Port",
					    "website": "https://www.salafestival.com/artfuel/program/view/489/people-colour-our-world"
					  },
					  {
					    "image": "imagination.jpg",
					    "imageCredit": "Georgina Willoughby",
					    "artist": ['John Blines','Michele Lane','Georgina Willoughby'],
					    "group": "REAL",
					    "title": "Rare Earth: Graft",
					    "venue": "Port Adelaide Lighthouse",
					    "address": "Commercial Rd",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1252/rare-earth-graft"
					  },
					  {
					    "image": "afterdark.jpg",
					    "imageCredit": null,
					    "artist": "",
					    "group": "Various",
					    "title": "AFTERDARK - SALA in the Port",
					    "overideAddress": "Commercial Road and St Vincent Street, Port Adelaide",
					    "venue": "29 Port Adelaide Venues",
					    "address": "Numerous streets",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1333/after-dark---sala-in-the-port",
					    "website2": "https://www.cityofpae.sa.gov.au/sitedata/unity/resources/files/Info_AfterDark_SALA.pdf"
					  },
					  {
					    "image": "doggos.jpg",
					    "imageCredit": "Rachel Darling",
					    "artist": ['Ned Bajik','Kathryn Bollen','Susan Brame','Ruth Carson','Bob Daly','Rachel Darling','Adelaide Manley-Dunn','Kurt Florimond','Steff Kennett','Rose Lemke','Robert Arthur Lockett','Jane M Macilwain','Kalyna Micenko','Fiona McCaul','Jenny Ramos','Robyn Russell','Shari Russell','Jane Shircore','Bianca Smith','Veronica Taltavull','Nicola Thompson','Peter Thompson','Bryan Tingey','Peter Tree','Clancy Warner','John Whitney','Trevor Wren','Juniper Darling'],
					    "group": "Port Adelaide Artists Forum",
					    "title": "Woof Woof",
					    "venue": "Gallery Yampu",
					    "address": "1 Jenkins Street,",
					    "suburb": "Birkenhead",
					    "website": "https://www.salafestival.com/artfuel/program/view/1031/woof-woof"
					  },
					  {
					    "image": "tailorwinston.jpg",
					    "imageCredit": "Tailor Winston",
					    "artist": ['Tailor Winston'],
					    "group": null,
					    "title": "Joyous Rage",
					    "venue": "Folklore Cafe",
					    "address": "11 Mundy Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/235/joyous-rage"
					  },
					  {
					    "image": "built.jpg",
					    "imageCredit": "Tony Kearney",
					    "artist": ['Tony Kearney'],
					    "group": "Film Users Group",
					    "title": "BUILT",
					    "venue": "The Packing Shed, Hart's Mill",
					    "address": "Mundy Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/981/built"
					  },
					  {
					    "image": "oddeties.jpg",
					    "imageCredit": "Annelise Forster",
					    "artist": ['Annelise Forster'],
					    "group": null,
					    "title": "Oddeties of Adelaide",
					    "venue": "The British Hotel",
					    "address": "13 North Parade",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/981/built"
					  },
					  {
					    "image": "tigerdonnaparker.jpg",
					    "imageCredit": "Donna Parker",
					    "artist": ['Donna Parker'],
					    "group": null,
					    "title": "Donna Parker",
					    "venue": "The British Hotel",
					    "address": "13 North Parade",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1188/donna-parker"
					  },
					  {
					    "image": "shannenbaker.jpg",
					    "imageCredit": "Shannen Baker",
					    "artist": ['Shannen Baker'],
					    "group": null,
					    "title": "BrushdLove",
					    "venue": "Drummer Boy Cafe",
					    "address": "132 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/77/brushdlove"
					  },
					  {
					    "image": "yodan.jpg",
					    "imageCredit": "Danielle Rickaby",
					    "artist": "",
					    "group": "YO.DAN",
					    "title": "The Under Story Layer",
					    "venue": "YO.DAN Studio",
					    "address": "15F Robe Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1405/the-under-story-layer"
					  },
					  {
					    "image": "timber.jpg",
					    "imageCredit": "Jason Hindes",
					    "artist": ['Jason Hindes'],
					    "group": null,
					    "title": "Timber Curve",
					    "venue": "hindesbydsign @ clarksons building",
					    "address": "136 Saint Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/716/timber-curve"
					  },
					  {
					    "image": "plasticbag.jpg",
					    "imageCredit": "Danica Gacesa McLean",
					    "artist": ['Danica Gacesa McLean'],
					    "group": null,
					    "title": "Artificial",
					    "venue": "The Darkroom",
					    "address": "154 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1466/artificial"
					  },
					  {
					    "image": "cottagekitchen.jpg",
					    "imageCredit": null,
					    "artist": "",
					    "group": "Community artists",
					    "title": "Mad for Mosics",
					    "venue": "Cottage Kitchen",
					    "address": "160 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": null
					  },
					  {
					    "image": "cult.jpg",
					    "imageCredit": "Lisa King",
					    "artist": ['Lisa King'],
					    "group": null,
					    "title": "Fractions",
					    "venue": "Cult & Harper",
					    "address": "Level 1, 168 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1089/fractions"
					  },
					  {
					    "image": "celestefoord.jpg",
					    "imageCredit": "Celeste Foord",
					    "artist": ['Celeste Foord'],
					    "group": null,
					    "title": "Little Lives",
					    "venue": "Port Mall",
					    "address": "173 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1341/little-lives"
					  },
					  {
					    "image": "herring.jpg",
					    "imageCredit": "Steven Herring",
					    "artist": ['Steven Herring'],
					    "group": null,
					    "title": "Octopus' s Garden",
					    "venue": "Mixed Creative",
					    "address": "32 Nile Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/813/octopus-s-garden"
					  },
					  {
					    "image": "minatures.jpg",
					    "imageCredit": "ilianthe kalloniatis",
					    "artist": ['Ilianthe kalloniatis'],
					    "group": null,
					    "title": "Miniature Worlds",
					    "venue": "Mixed Creative",
					    "address": "32 Nile Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/297/miniature-worlds"
					  },
					  {
					    "image": "herenow.jpg",
					    "imageCredit": "Gretchen Gordon",
					    "artist": ['Gretchen Gordon'],
					    "group": null,
					    "title": "HERE NOW",
					    "venue": "Fontanelle Gallery & Studios",
					    "address": "175 St Vincent Sreet",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1581/here-now"
					  },
					  {
					    "image": "tessellate.jpg",
					    "imageCredit": "Jasmine Jones",
					    "artist": ['Jasmine Jones','Matina Kallushis','Josh Maloney','Ellese McLindin','Scott Pyle','Malyka Uy'],
					    "group": "Tutti Visual Arts Studio",
					    "title": "Tessellate",
					    "venue": "Fontanelle Workshop",
					    "address": "175 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1267/tessellate"
					  },
					  {
					    "image": "pcac.jpg",
					    "imageCredit": "David Baker",
					    "artist": "",
					    "group": "Port Community Arts Centre Members",
					    "title": "SALA:ALAS",
					    "venue": "Black Diamond Gallery",
					    "address": "66 Commercial Road",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/20/salaalas---port-community-arts-centre-members-exhibition"
					  },
					  {
					    "image": "gardenisland.jpg",
					    "imageCredit": "Kym Murphy",
					    "artist": ['Laura Wills','Kym Murphy','Danielle Rickaby','Kaz Pedersen','Nicki Manning'],
					    "group": null,
					    "title": "Healthy Port River",
					    "venue": "Black Diamond Gallery",
					    "address": "66 Commercial Road",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1168/healthy-port-river"
					  },
					  {
					    "image": "dolphins.jpg",
					    "imageCredit": "Richard John",
					    "artist": ['Mikaela Thomas','Winnie Fox','Richard John'],
					    "group": null,
					    "title": "Dolphins, the water and a sustainable environment",
					    "venue": "The Lighthouse Wharf Hotel",
					    "address": "1 Commercial Road",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1368/dolphins-the-water-and-a-sustainable-environment"
					  },
					  {
					    "image": "wren.jpg",
					    "imageCredit": "Trevor Wren",
					    "artist": ['Trevor Wren'],
					    "group": null,
					    "title": "Windjammer",
					    "venue": "Dockside Tavern",
					    "address": "130 Lipson Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1558/windjammer"
					  },
					  {
					    "image": "desertbloom.jpg",
					    "imageCredit": "JLZ ROSE",
					    "artist": "JLZ ROSE",
					    "group": null,
					    "title": "COLOUR at KORKED",
					    "venue": "KORKED",
					    "address": "3 Divett Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/394/colour-at-korked"
					  },
					  {
					    "image": "pubshow.jpg",
					    "imageCredit": "Billie Justice Thomson",
					    "artist": ['Billie Justice Thomson'],
					    "group": null,
					    "title": "The Pub Show",
					    "venue": "Port Admiral Hotel",
					    "address": "55 Commercial Road",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1417/billie-justice-thomson-the-pub-show"
					  },
					  {
					    "image": "jackaloupe.jpg",
					    "imageCredit": "Nancy Forrester",
					    "artist": ['Nancy Forrester','Kathy Harrison','Susan McKenzie','Lynn McKeown','Mandi Glynn-Jones','Kaz Pedersen'],
					    "group": null,
					    "title": "6 @ Jackalope",
					    "venue": "Jackalope Gallery",
					    "address": "19 Calton Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/421/6--jackalope"
					  },
					  {
					    "image": "fishmarket.jpg",
					    "imageCredit": "Luiza Michalewicz",
					    "artist": ['Luiza Michalewicz'],
					    "group": null,
					    "title": "Fish Market in Muscat",
					    "venue": "Michonne Wine Bar",
					    "address": "229 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/891/fish-market-in-muscat"
					  },
					  {
					    "image": "fabricatedme.jpg",
					    "imageCredit": "Nadia Caon",
					    "artist": ['Nadia Caon'],
					    "group": null,
					    "title": "'Fabricated Me'",
					    "venue": "Yarn Trader",
					    "address": "261 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/946/fabricated-me"
					  },
					  {
					    "image": "lineandspace.jpg",
					    "imageCredit": "Mandi Glynn-Jones",
					    "artist": ['Mandi Glynn-Jones','Jason Hindes'],
					    "group": null,
					    "title": "Line and Space",
					    "venue": "True Hemp culture",
					    "address": "257 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/210/line-and-space"
					  },
					  {
					    "image": "studio.jpg",
					    "imageCredit": "Janelle Gaudet",
					    "artist": ['Janelle Gaudet,Wendy Lindsay'],
					    "group": "Friends of Studio 99",
					    "title": "Out of the Wardrobe and More",
					    "venue": "Studio 99 Lipson Street",
					    "address": "99 Lipson Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/902/out-of-the-wardrobe-and-more"
					  },
					  {
					    "image": "elizabethclose.jpg",
					    "imageCredit": "Elizabeth Close",
					    "artist": ['Elizabeth Close'],
					    "group": null,
					    "title": "Red Dust, Rough Diamond",
					    "venue": "Black Diamond Tattoo",
					    "address": "232 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/247/red-dust-rough-diamond"
					  },
					  {
					    "image": "cheesedreams.jpg",
					    "imageCredit": "Gabriel Cunnett",
					    "artist": ['Gabriel Cunnett'],
					    "group": null,
					    "title": "Cheese Dreams",
					    "venue": "La Popular Taqueria",
					    "address": "226 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/686/cheese-dreams"
					  },
					  {
					    "image": "twinflames.jpg",
					    "imageCredit": "Cathy Armfield",
					    "artist": ['Cathy Armfield'],
					    "group": null,
					    "title": "Sacred Geometry Mandalas meet Contemporary Art",
					    "venue": "Om Mandalas Art Gallery & Well Being Studio",
					    "address": "216 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1144/sacred-geometry-mandalas-meet-contemporary-art"
					  },
					  {
					    "image": "sophiemosimann.jpg",
					    "imageCredit": "Sophie Mosimann",
					    "artist": ['Sophie Mosimann'],
					    "group": null,
					    "title": "Port Glory",
					    "venue": "Port Blooms",
					    "address": "72 Commercial Road",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1396/port-glory"
					  },
					  {
					    "image": "railwayworkshop.jpg",
					    "imageCredit": "Tony Kearney",
					    "artist": ['Tony Kearney','Sandra Elms'],
					    "group": null,
					    "title": "Syria that was: Images of the Hejaz Railway Workshop",
					    "venue": "National Railway Museum",
					    "address": "76 Lipson Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1357/syria-that-was-images-of-the-hejaz-railway-workshop"
					  },
					  {
					    "image": "portemporium.jpg",
					    "imageCredit": "Amanda Phillips",
					    "artist": ['Amanda Phillips','Sam Kitoko','Ray Nash','Peter Thompson','Joshua Olavesen','Simon Aberle','Damien Fox','Vicki Bloffwitch','Hannah Williams','James Carter','Wendz Flevill','Dannielle Schriever','Yuk Chan','Cass Heath','Lindsay Poland','Mario Paraskeva'],
					    "group": "The Port Adelaide Emporium",
					    "title": "Art Lives In The Port!",
					    "venue": "The Port Adelaide Emporium",
					    "address": "113 Commercial Road",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1361/art-lives-in-the-port"
					  },
					  {
					    "image": "pearshaped.jpg",
					    "imageCredit": null,
					    "artist": "",
					    "group": "The Pear Collective",
					    "title": "The Pear Shaped",
					    "venue": "The Pear",
					    "address": "49 Sussex Street",
					    "suburb": "Alberton",
					    "website": "https://www.salafestival.com/artfuel/program/view/1489/the-pear-shaped"
					  },
					  {
					    "image": "tinytraveller.jpg",
					    "imageCredit": null,
					    "artist": ['Sam Oster', 'Cynthia Gemus'],
					    "group": null,
					    "title": "The Tintype Traveller Workshop",
					    "venue": "Black Diamond Gallery",
					    "address": "66 Commercial Road",
					    "suburb": "Port Adelaide",
					    "website": null
					  },
					  {
					    "image": "identity.jpg",
					    "imageCredit": "Rosy",
					    "artist": "",
					    "group": null,
					    "title": "Identity Explorers",
					    "venue": "St Brigid's School",
					    "address": "45 Way Street",
					    "suburb": "Kilburn",
					    "website": "https://www.salafestival.com/artfuel/program/view/595/identity-explorers"
					  },
					  {
					    "image": "atmosphere.jpg",
					    "imageCredit": "Tina Nguyen",
					    "artist": "",
					    "group": "Our Lady of the Sacred Heart College community",
					    "title": "ATMOSPHERE",
					    "venue": "Our Lady of the Sacred Heart College",
					    "address": "496 Regency Road",
					    "suburb": "Enfield",
					    "website": "https://www.salafestival.com/artfuel/program/view/595/identity-explorers"
					  },
					  {
					    "image": "spirit.jpg",
					    "imageCredit": "Kate Marie Lewis",
					    "artist": ['Kate Marie Lewis'],
					    "group": null,
					    "title": "Yoga Elements",
					    "venue": "Pane e Latte",
					    "address": "587 Regency Road",
					    "suburb": "Broadview",
					    "website": "https://www.salafestival.com/artfuel/program/view/147/yoga-elements"
					  },
					  {
					    "image": "rexjacobs.jpg",
					    "imageCredit": "Rex Jacobs",
					    "artist": ['Rex Jacobs'],
					    "group": null,
					    "title": "Rex Jacobs Unique Glass Art",
					    "venue": "Rex Jacobs Glass Art",
					    "address": "22 Jolly Avenue",
					    "suburb": "Northfield",
					    "website": "https://www.salafestival.com/artfuel/program/view/1428/rex-jacobs-unique-glass-art"
					  },
					  {
					    "image": "fishoutofwater.jpg",
					    "imageCredit": "Clancy Warner",
					    "artist": ['Clancy Warner'],
					    "group": null,
					    "title": "Clancy Warner- The Art of Making (a studio warming)",
					    "venue": "Firgun & Fiire Gallery & Studio",
					    "address": "20 Jetty Road",
					    "suburb": "Largs Bay",
					    "website": "https://www.salafestival.com/artfuel/program/view/487/clancy-warner--the-art-of-making-a-studio-warming"
					  },
					  {
					    "image": "live.jpg",
					    "imageCredit": "Lisa King",
					    "artist": ['Lisa King'],
					    "group": null,
					    "title": "Live Painting for Fractions",
					    "venue": "Cult & Harper",
					    "address": "Level 1, 168 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": "https://www.salafestival.com/artfuel/program/view/1089/fractions"
					  },
					  {
					    "image": "kalyna.jpg",
					    "imageCredit": "Kalyna Micenko",
					    "artist": ['Kalyna Micenko','Bob Daly'],
					    "group": "SpinFX AustrAliA",
					    "title": "Sooper Dooper Studio Sale",
					    "venue": "SpinFX AustrAliA",
					    "address": "Unit 3/ 31 Divett Street",
					    "suburb": "Port Adelaide",
					    "website": null
					  },
					  {
					    "image": "fontanelle.jpg",
					    "imageCredit": null,
					    "artist": ['Brigid Noone', 'Ben Leslie', 'eDuard Helmbold', 'KAB 101', 'Min Wong', 'Nigel Matejcic', 'Scott Pyle', 'Steven Bellosguardo', 'Sue Kneebown', 'Tailor Winston', 'Tony Wilson'],
					    "group": "Fontanelle artists",
					    "title": "Fontanelle Open Studio",
					    "venue": "Fontanelle Gallery & Studios",
					    "address": "175 St Vincent Street",
					    "suburb": "Port Adelaide",
					    "website": null
					  },
					  {
					    "image": "studiopotters.jpg",
					    "imageCredit": null,
					    "artist": "",
					    "group": "Studio Potters SA",
					    "title": "Fired Up....Open Studio weekend",
					    "venue": "Studio Potters SA",
					    "address": "1 Fourth Avenue",
					    "suburb": "Klemzig",
					    "website": "https://www.salafestival.com/artfuel/program/view/635/fired-upopen-studio-weekend"
					  }
					]

			}
		},
		methods: {
			clearSuburbs: function() {
				var i
				for(i=0; i < this.suburbList.length; i++) {
					this.suburbList[i].active = false;
				}
				this.suburbFilter = []
			},
        	toggleSuburb: function(index, name, active) {
        		this.suburbFilter = []

				var i
				for(i=0; i < this.suburbList.length; i++) {
					this.suburbList[i].active = false;
				}

        		if(active) {
        			this.suburbFilter.push(name)
        		} else {
					this.suburbFilter.splice( this.suburbFilter.indexOf(name), 1)
        		}

				Vue.set(this.suburbList, index, {active:active, name: name})
        		
        	}
		},

		computed: {

			filteredItems() {

				let items = this.cards
				items = items.filter((p) => {

					var i

					for(i=0; i < this.suburbFilter.length; i++) {
						
						if(p.suburb.indexOf( this.suburbFilter[i] ) >-1) {
							
						} else { return false }

					}

					return true

				})

				return items
			}

		}

	}
</script>
<style>
.iconLinks { line-height: 1.2em; }
.iconLinks i { margin-bottom: .2em; }

ul.serviceFilter li { background: #666; color: #888;}
ul.serviceFilter li.active { background: #17C4EE; color: #fff; }
ul.serviceFilter li:hover { cursor: pointer; }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/events/sala/Sala.vue